import React from "react";
import "./Project.scss";
import { useParams, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Slider from "../components/Slider";

const Project = ({
  projects = [],
  activeInfoIds,
  setActiveInfoIds,
  setShowInfo,
}) => {
  const { projectUrl } = useParams();

  // Find project based on url parameter
  const project = projects.find((p) => p.fields?.url === projectUrl);

  if (projects.length > 0 && !project) {
    return <Navigate to="/" replace />;
  }

  if (!project) return null;

  return (
    <div className="project-page">
      <Helmet>
        <title>{`${project.fields?.titre} - Laure Philippe`}</title>
      </Helmet>
      <Slider
        photos={project.fields?.photos || []}
        activeInfoIds={activeInfoIds}
        setActiveInfoIds={setActiveInfoIds}
        setShowInfo={setShowInfo}
      />
    </div>
  );
};

export default Project;
